<template>
  <section class="section ourteam dull-bg">
    <div class="container">
      <div class="section-heading">
        <h2><span>Đội ngũ của chúng tôi</span></h2>
     
      </div>
      <div class="featured-slider-group p-0">
        <div class="owl-carousel team-slider owl-theme">
          <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
            <Slide v-for="record in OurTeams" :key="record.id">
              <div class="team-item">
                <div class="info text-center">
                  <div class="wrap">
                    <div class="prfile-pic">
                      <img
                        :src="require(`@/assets/img/aboutus/${record.Image}`)"
                        class="img-fluid"
                        alt="Team"
                      />
                    </div>
                    <div class="short-info">
                      <h4>{{ record.Name }}</h4>
                      <h6>{{ record.Role }}</h6>
                    </div>
                  </div>
                  <div class="more">
                    <div class="short-info">
                      <h4>{{ record.Name }}</h4>
                      <h6>{{ record.Role }}</h6>
                    </div>
                    <p>
                      {{ record.Description }}
                    </p>
                    <ul class="social-medias d-inline-flex">
                      <li class="facebook">
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-facebook-f"></i
                        ></a>
                      </li>
                      <li class="instagram">
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-instagram"></i
                        ></a>
                      </li>
                      <li class="twitter">
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-twitter"></i
                        ></a>
                      </li>
                      <li class="pinterest">
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-pinterest"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Slide>
            <template #addons>
              <Navigation />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import OurTeams from "@/assets/json/our-teams.json";
export default {
  data() {
    return {
      OurTeams: OurTeams,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
